import styled from 'styled-components';

export const Secao = styled.section`
  margin-bottom: 16px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 10px;
  background-color: ${({ theme }) => theme.cardBackground};
  box-shadow: 0 1px 2px ${({ theme }) => theme.shadowColor};
  overflow: hidden;
`;

export const Cabecalho = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.textColor};
  text-align: left;

  &:hover {
    background-color: ${({ theme }) => theme.lightColor};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.primaryColor};
    outline-offset: -2px;
  }
`;

export const Chevron = styled.span<{ aberto: boolean }>`
  display: inline-flex;
  margin-left: auto;
  font-size: 12px;
  color: ${({ theme }) => theme.darkGray};
  transition: transform 0.15s ease;
  transform: rotate(${({ aberto }) => (aberto ? '180deg' : '0deg')});
`;

export const Badges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-left: 4px;
`;

export const Badge = styled.span`
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  color: ${({ theme }) => theme.primaryColor};
  background-color: ${({ theme }) => theme.lightColor};
  border: 1px solid ${({ theme }) => theme.borderColor};
`;

export const Corpo = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;
  padding: 4px 16px 16px;
  border-top: 1px solid ${({ theme }) => theme.borderColor};
`;
